import {mapGetters} from 'vuex'

export const contentLanguage = {
  data(){
    return{
      selectedLanguage: null,
      contentLanguageAccess: process.env.VUE_APP_CONTENT_MULTI_LANGUAGE,
    }
  },
  computed: {
    ...mapGetters({
      languages: 'languageOptions',
    }),
  },
  methods: {
    setLanguage() {
      localStorage.setItem('PCMSContentLanguage', this.selectedLanguage);
      this.reloadContent();
    },
  },
  mounted() {
    let contentLang = localStorage.getItem('PCMSContentLanguage');
    if(contentLang && contentLang > 0){
      this.selectedLanguage = Number(contentLang);
    } else {
      this.selectedLanguage = 1;
      this.setLanguage();
    }
  },

};
